export const getBuildingImageByLevel = (level: number): number => {
  if (level > 0 && level < 5) return 1
  if (level >= 5 && level < 9) return 2
  if (level >= 9 && level < 13) return 3
  if (level >= 13 && level < 17) return 4
  if (level >= 17 && level <= 20) return 5
  return level
}
